var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
import { jsx as _jsx } from "react/jsx-runtime";
import styled from 'styled-components';
var CenteredSignContainer = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 48px;\n  box-sizing: border-box;\n"], ["\n  display: flex;\n  height: 100%;\n  justify-content: center;\n  align-items: center;\n  padding: 48px;\n  box-sizing: border-box;\n"])));
export default function CenteredSign(props) {
    return (_jsx(CenteredSignContainer, { children: _jsx("div", { children: props.children }, void 0) }, void 0));
}
var templateObject_1;
//# sourceMappingURL=CenteredSign.js.map